import axios from "axios";
import configs from "../../../configurations/configs";

const IP = configs.SERVER_IP;

const state = {
  session: JSON.parse(localStorage.getItem("eposta_session")),
  signUpResponse: {},
  verificationResponse: {},
  loginResponse: {},
  message: {},
  status: "",
  account_data: {},
};

const getters = {
  getAccount: (state) => state.account_data, //JSON.parse(localStorage.getItem("eposta_account")),
  getClientId: () =>
    JSON.parse(localStorage.getItem("eposta_session")).client_id,
  getClientPhone: () =>
    JSON.parse(localStorage.getItem("eposta_session")).phone,
  getSignUpResponse: (state) => state.signUpResponse,
  getVerificationResponse: (state) => state.verificationResponse,
  getLoginResponse: (state) => state.loginResponse,
  getErrorMessage: (state) => state.message,
};

const actions = {
  async userLogin({ commit }, data) {
    await axios
      .post(IP + "/client/login", data)
      .then((response) => {
        console.log(response.data);
        commit("setLoginResponse", response);
      })
      .catch((error) => {
        console.log(error.response);
        commit("setLoginError", error.response.data);
      });
  },
  async codeVerification({ commit }, data) {
    await axios
      .post(IP + "/client/login/verify", data)
      .then((response) => {
        console.log(response.data);
        commit("setVerificationResponse", response);
      })
      .catch((error) => {
        commit("setVerificationError", error.response.data);
      });
  },
  async signup({ commit }, data) {
    await axios
      .post(IP + "/client/register", data)
      .then((response) => {
        commit("setSignUpResponse", response);
      })
      .catch((error) => {
        commit("setSignUpError", error.response.data);
      });
  },

  async fetchAccountInfo({ commit }, data) {
    await axios
      .post(IP + "/client/profile", data)
      .then((response) => {
        if (localStorage.getItem("eposta_account") == null) {
          localStorage.setItem(
            "eposta_account",
            JSON.stringify(response.data.data)
          );
        }

        commit("setAccountInfoResponse", response);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};

const mutations = {
  setLoginResponse: (state, response) => {
    state.loginResponse = response.data;
  },
  setVerificationResponse: (state, response) => {
    state.verificationResponse = response.data;
  },
  setSignUpResponse: (state, response) => {
    state.signUpResponse = response.data;
  },
  setAccountInfoResponse: (state, response) => {
    state.account_data = response.data.data;
  },
  setLoginError: (state, error) => {
    state.message = error;
  },
  setSignUpError: (state, error) => {
    state.message = error;
  },
  setVerificationError: (state, error) => {
    state.message = error;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
